import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsTable } from "react-icons/bs";
import {
  exportToTxt,
  generateExcel,
  numberWithCommas,
} from "../../utils/customFunction";
import { useSelector } from "react-redux";
import html2pdf from "html2pdf.js";
import CardColComponent from "../genericCardComponent/CardColComponent";
import ReportTemplates from "../../components/ReportTemplate/ReportTemplate";
import moment from "moment";
import HBLLogo from "../../assets/image.png";
import { getFundByAmc, getFunds } from "../../stores/services/funds.service";
import Select from "react-select";
import {
  getAllProvidentFunds,
  getAllLoanApplications,
} from "../../stores/services/provident-funds.service";
import { getAllCompanies } from "../../stores/services/company.service";

function SettlementReportEmployee() {
  const ColumnHeading = [
    { label: "Fund Code", value: "Fund Code" },
    { label: "Month", value: "Month" },
    { label: "Employee Contribution", value: "Employee Contribution" },
    { label: "Employer Contribution", value: "Employer Contribution" },
    { label: "Profit", value: "Profit" },
    { label: "Total", value: "Total" },
    { label: "Remarks", value: "Remarks" },
  ];

  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const contentRef = useRef(null);

  const [ColumnArr, setColumnArr] = useState(ColumnHeading);
  const [selectedValues, setSelectedValues] = useState({
    heading: "",
    sub_heading: "",
    columns: ColumnHeading.map((col) => col.value),
    balance: [],
  });

  const [fontSizeVal, setFontSizeVal] = useState(18);
  const [paperSizeVal, setPaperSizeVal] = useState("A4");
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM"));
  const [layoutVal, setLayoutVal] = useState("Landscape");
  const [marginPDF, setMarginPDF] = useState("1cm");
  const [scalePDF, setScalePDF] = useState(0.5);
  const [screenSizePerPdf, setScreenSizePerPdf] = useState<any>();
  const [dimensionOfPages, setDimensionOfPages] = useState<any>();
  const pdfExportComponent = useRef(null);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState<any[]>([]);
  const [fund, setFund] = useState("");
  const [fundLoading, setFundLoading] = useState<boolean>(false);
  const [allFunds, setAllFunds] = useState<any[]>([]);
  const [searchCode, setSearchCode] = useState("");
  const [searchName, setSearchName] = useState("");
  const [summary, setSummary] = useState({
    totalEmployeeContribution: 0,
    totalEmployerContribution: 0,
    totalProfit: 0,
    grandTotal: 0,
    totalLoansTaken: 0,
    currentLoanBalance: 0,
    totalLoanAdjustments: 0,
    loan_taken: 0,
    netAmount: 0,
    folio_no: "",
    employee_name: "",
    employee_cnic: "",
  });

  const [folio, setFolio] = useState<any>("");
  const [allFolios, setAllFolios] = useState<any[]>([]);

  const [loadingCompany, setLoadingCompany] = useState(false);
  const [companyOptions, setCompanyOptions] = useState<any[]>([]);
  const [companyName, setCompanyName] = useState<any>();

  // Fetch Companies
  useEffect(() => {
    const fetchAllCompanies = async () => {
      try {
        setLoadingCompany(true);
        const resp = await getAllCompanies({ email, fetch_all: "all" });
        if (resp.data.status === 200) {
          const options = resp.data.data.map((data: any) => ({
            ...data,
            value: data.company_code,
            label: `${data.name_of_company} (${data.company_code})`,
          }));
          setCompanyOptions(options);
        }
      } catch (error) {
        toast.error("Failed to load companies");
      } finally {
        setLoadingCompany(false);
      }
    };
    fetchAllCompanies();
  }, []);

  const getAllEmployees = async (fundIs: string) => {
    try {
      if (!fundIs) {
        setAllFolios([]);
        return;
      }

      const response = await getAllProvidentFunds(email, amc_code, fundIs);
      if (response.data.status === 200) {
        setAllFolios(
          response.data.data.map((data) => {
            return {
              ...data,
              label: `${data.employee_name} (${data.folio_no})`,
              value: data.folio_no,
            };
          }) || [],
        );
      }
    } catch (error) {
      toast.error("Failed to load employees.");
    }
  };
  // Fetch Funds when Company changes
  useEffect(() => {
    const getAllFunds = async () => {
      if (!companyName?.value) return;
      try {
        const res = await getFunds({ email, company_name: companyName.value });
        setAllFunds(res.data.data || []);
      } catch (error) {
        toast.error("Failed to load funds");
      }
    };
    getAllFunds();
  }, [companyName]);

  // Search function with loan integration
  const searchData = async () => {
    if (!fund) {
      toast.error("Fund should not be empty");
      return;
    }
    if (!folio?.value) {
      toast.error("Please Select an Employee");
      return;
    }

    try {
      setLoading(true);

      // 1. Fetch Provident Fund Data
      const pfResponse = await getAllProvidentFunds(
        email,
        amc_code,
        fund,
        folio?.value || "",
        "",
        "",
        searchName,
        "true",
      );

      if (pfResponse.data.status !== 200 || !pfResponse.data.data?.length) {
        setTableData([]);
        setSummary({
          totalEmployeeContribution: 0,
          totalEmployerContribution: 0,
          totalProfit: 0,
          grandTotal: 0,
          totalLoansTaken: 0,
          currentLoanBalance: 0,
          loan_taken: 0,
          totalLoanAdjustments: 0,
          netAmount: 0,
          folio_no: "",
          employee_name: "",
          employee_cnic: "",
        });
        toast.error("No record found!");
        return;
      }

      const dataIs = pfResponse.data.data;
      setTableData(dataIs);

      // 2. Extract basic employee info
      const firstRecord = dataIs[0];
      const folio_no = firstRecord.folio_no;
      const employee_name = firstRecord.employee_name;
      const employee_cnic = firstRecord.employee_cnic;

      // 3. Contribution Totals
      const totalEmployeeContribution = dataIs.reduce(
        (sum, item) => sum + parseFloat(item.employee_contribution || 0),
        0,
      );
      const totalEmployerContribution = dataIs.reduce(
        (sum, item) => sum + parseFloat(item.employer_contribution || 0),
        0,
      );
      const totalProfit = dataIs.reduce(
        (sum, item) => sum + parseFloat(item.profit || 0),
        0,
      );
      const grandTotal = dataIs.reduce(
        (sum, item) => sum + parseFloat(item.total || 0),
        0,
      );
      const totalLoanAdjustments = dataIs.reduce(
        (sum, item) => sum + parseFloat(item.loan_adjustment || 0),
        0,
      );

      // 4. Fetch Loan Applications
      let loanApps: any[] = [];
      try {
        const loanResponse = await getAllLoanApplications(
          email,
          amc_code,
          fund,
          folio_no,
          "", // all statuses
        );
        if (loanResponse.data.status === 200) {
          loanApps = loanResponse.data.data || [];
        }
      } catch (err) {
        console.warn("Failed to fetch loan applications");
      }

      const totalLoansTaken = loanApps.length;
      const activeLoan = loanApps.find(
        (loan) =>
          loan.loan_status === "ACCEPTED" && (loan.remaining_loan || 0) > 0,
      );
      const currentLoanBalance = activeLoan ? activeLoan.remaining_loan : 0;
      const loan_taken = activeLoan ? activeLoan.loan_amount : 0;

      // 5. Update Summary
      setSummary({
        totalEmployeeContribution,
        totalEmployerContribution,
        totalProfit,
        grandTotal,
        netAmount:
          totalEmployeeContribution +
          totalEmployerContribution -
          currentLoanBalance,
        totalLoansTaken,
        loan_taken,
        currentLoanBalance,
        totalLoanAdjustments,
        folio_no,
        employee_name,
        employee_cnic,
      });
    } catch (error: any) {
      setTableData([]);
      setSummary({
        totalEmployeeContribution: 0,
        totalEmployerContribution: 0,
        totalProfit: 0,
        grandTotal: 0,
        loan_taken: 0,
        totalLoansTaken: 0,
        currentLoanBalance: 0,
        totalLoanAdjustments: 0,
        netAmount: 0,
        folio_no: "",
        employee_name: "",
        employee_cnic: "",
      });
      toast.error("No record found!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const elements = document.querySelectorAll(
      "#test",
    ) as NodeListOf<HTMLElement>;
    elements.forEach((element) => {
      element.style.setProperty("font-size", `${fontSizeVal}px`, "important");
    });
  }, [fontSizeVal, selectedValues, loading]);

  const fixedOrder = [
    "Month",
    "Employee Code",
    "Employee Name",
    "CNIC",
    "Employee Contribution",
    "Employer Contribution",
    "Profit",
    "Total",
    "Remarks",
  ];

  const reorderColumns = (columns: string[], order: string[]) => {
    return order.filter((column) => columns.includes(column));
  };

  // Export Handlers (unchanged)
  const handleDownloadExcel = () => {
    const reorderedColumns = reorderColumns(selectedValues.columns, fixedOrder);
    const ArrayData = tableData.map((entry) => {
      const result: any = {};
      reorderedColumns.forEach((column) => {
        result[column] = entry[column] || "";
      });
      return result;
    });
    generateExcel(
      "PF Funds Report",
      "PF Funds Report",
      "File",
      "File",
      "DCCL",
      [],
      reorderedColumns,
      ArrayData,
      [],
      [],
    );
  };

  const handleTXT = () => {
    const reorderedColumns = reorderColumns(selectedValues.columns, fixedOrder);
    const ArrayData = tableData.map((entry) => {
      const result: any = {};
      reorderedColumns.forEach((column) => {
        result[column] = entry[column] || "";
      });
      return result;
    });
    exportToTxt("", selectedValues, ArrayData, "PF Funds Report");
  };

  const handleGeneratePdf = () => {
    const element = contentRef.current;
    if (!element) return;
    const fileName = "PF-Funds-Report.pdf";
    const options = {
      filename: fileName,
      margin: [10, 3, 20, 3],
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 1 },
      jsPDF: {
        unit: "mm",
        format: paperSizeVal || "A4",
        orientation: layoutVal === "Landscape" ? "landscape" : "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    html2pdf()
      .from(element)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          pdf.setTextColor(128, 128, 128);
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          pdf.text(
            "This is a computer-generated report from MACS 360. No signature is required.",
            pageWidth / 2,
            pageHeight - 10,
            { align: "right" },
          );
        }
      })
      .save();
  };

  const renderFundsDropdown = () => {
    return allFunds.map((item: any) => {
      if (item.nature === "Special Managed Account") {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code}) - SMA`,
        };
      } else {
        return {
          value: item.symbol_code,
          label: `${item.fund_name} (${item.symbol_code})`,
        };
      }
    });
  };

  const selectedFundName = allFunds.find((item) => item.symbol_code === fund)
    ? allFunds.find((item) => item.symbol_code === fund)?.nature ===
      "Special Managed Account"
      ? {
          value: fund,
          label: `${
            allFunds.find((f) => f.symbol_code === fund)?.fund_name
          } (${fund}) - SMA`,
        }
      : {
          value: fund,
          label: `${
            allFunds.find((f) => f.symbol_code === fund)?.fund_name
          } (${fund})`,
        }
    : null;

  const customStyles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    option: (styles: any, { isFocused, isSelected }: any) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
          ? "hsla(291, 64%, 42%, 1)"
          : undefined,
      zIndex: 1,
    }),
    menuList: (styles: any) => ({
      ...styles,
      background: theme === "dark" ? "#3b3b3b" : "#ffffff",
      color: theme === "dark" ? "white" : "",
    }),
    menu: (base: any) => ({ ...base, zIndex: 100 }),
    control: (base: any, state: any) => ({
      ...base,
      background: theme === "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
          ? "#2b3553"
          : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: "#ba54f5",
      },
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: theme === "dark" ? "white" : "black",
    }),
    input: (base: any) => ({
      ...base,
      color: theme === "dark" ? "white" : "black",
    }),
  };

  // Employee Summary
  const PFFundSummary = [
    { title: "Employee Code", value: summary.folio_no },
    { title: "Employee Name", value: summary.employee_name },
    { title: "CNIC", value: summary.employee_cnic },
  ];

  // Contribution + Loan Summary
  const PFfundDetailsArr = [
    // {
    //     title: "Total Employee Cont",
    //     value: summary.totalEmployeeContribution,
    //     isAmount: true,
    //     fixed: 2,
    // },
    // {
    //     title: "Total Employer Cont",
    //     value: summary.totalEmployerContribution,
    //     isAmount: true,
    //     fixed: 2,
    // },
    {
      title: "Total Cont",
      value:
        (summary?.totalEmployerContribution || 0) +
        (summary?.totalEmployeeContribution || 0),
      isAmount: true,
      fixed: 2,
    },
    {
      title: "Total Profit",
      value: summary.totalProfit,
      isAmount: true,
      fixed: 2,
    },
    {
      title: "Total Loans Taken",
      value: summary.totalLoansTaken,
      isAmount: false,
    },
    ...(summary.currentLoanBalance > 0
      ? [
          {
            title: "Current Loan Amount",
            value: summary.loan_taken,
            isAmount: true,
            fixed: 2,
          },
          {
            title: "Current Loan Paid",
            value: summary.loan_taken - summary.currentLoanBalance,
            isAmount: true,
            fixed: 2,
          },
          {
            title: "Current Loan Remaining",
            value: summary.currentLoanBalance,
            isAmount: true,
            fixed: 2,
          },
        ]
      : []),
    {
      title: "Net Total",
      value: summary.netAmount,
      isAmount: true,
      fixed: 2,
    },
  ].filter((item) => item.value !== undefined && item.value !== null);

  const numberToWords = (num: number): string => {
    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];

    if (num === 0) return "Zero";
    if (num < 10) return ones[num];
    if (num < 20) return teens[num - 10];
    if (num < 100)
      return (
        tens[Math.floor(num / 10)] + (num % 10 ? " " + ones[num % 10] : "")
      );
    if (num < 1000)
      return (
        ones[Math.floor(num / 100)] +
        " Hundred" +
        (num % 100 ? " " + numberToWords(num % 100) : "")
      );
    if (num < 100000)
      return (
        numberToWords(Math.floor(num / 1000)) +
        " Thousand" +
        (num % 1000 ? " " + numberToWords(num % 1000) : "")
      );
    return (
      numberToWords(Math.floor(num / 100000)) +
      " Lakh" +
      (num % 100000 ? " " + numberToWords(num % 100000) : "")
    );
  };

  const decentStyle = (valueIs) => {
    return (
      <CardColComponent
        subTitle={valueIs}
        simple={true}
        amount={true}
        forTxn={true}
      />
    );
  };

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Container fluid>
            <ToastContainer limit={1} />
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Final Settlement Report</h4>
              </div>
              <div className="card-body">
                <Row className="align-items-center">
                  <Col className="form-group col-md-3">
                    <label>
                      Company Name <span className="color-amber">*</span>
                    </label>
                    <Select
                      className="react-select info"
                      isLoading={loadingCompany}
                      value={companyName}
                      onChange={setCompanyName}
                      menuPortalTarget={document.body}
                      menuShouldBlockScroll
                      isClearable
                      isSearchable
                      options={companyOptions}
                      styles={customStyles}
                    />
                  </Col>
                  <Col md="3" xs="12" className="mb-3 mb-md-0">
                    <div className="form-group">
                      <label>Fund</label>
                      {fundLoading ? (
                        <div className="form-control w-100">
                          <i className="fa fa-spinner fa-spin fa-1x"></i>
                        </div>
                      ) : (
                        <Select
                          value={selectedFundName}
                          onChange={(e) => {
                            setFund(e?.value || "");
                            getAllEmployees(e?.value || "");
                          }}
                          menuPortalTarget={document.body}
                          menuShouldBlockScroll
                          isClearable
                          isSearchable
                          options={renderFundsDropdown()}
                          styles={customStyles}
                        />
                      )}
                    </div>
                  </Col>

                  {/* <Col md="3" xs="12" className="mb-3 mb-md-0">
                    <div className="form-group">
                      <label>From Year</label>
                      <input
                        type="month"
                        className="form-control py-1"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        style={{
                          colorScheme: theme === "light" ? "light" : "dark",
                        }}
                      />
                    </div>
                  </Col>
                  <Col md="3" xs="12" className="mb-3 mb-md-0">
                    <div className="form-group">
                      <label>To Year</label>
                      <input
                        type="month"
                        className="form-control py-1"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        style={{
                          colorScheme: theme === "light" ? "light" : "dark",
                        }}
                      />
                    </div>
                  </Col> */}

                  <Col md="3" xs="12" className="mb-3 mb-md-0">
                    <div className="form-group">
                      <label>Select Employee</label>
                      <Select
                        value={folio}
                        onChange={(e) => setFolio(e || "")}
                        isClearable
                        isSearchable
                        options={allFolios}
                        styles={customStyles}
                        menuPortalTarget={document.body}
                        menuShouldBlockScroll
                      />
                    </div>
                  </Col>

                  <Col
                    md="auto"
                    xs="6"
                    className="d-flex align-items-end mt-3 mb-md-0"
                  >
                    <button
                      className="btn btn-primary"
                      onClick={searchData}
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                          />
                          <span className="ms-1">Loading...</span>
                        </>
                      ) : (
                        "Search"
                      )}
                    </button>
                  </Col>
                </Row>
              </div>
            </div>

            <div className="card mt-3">
              <div className="card-body">
                {tableData.length > 0 && (
                  <Row>
                    <ReportTemplates
                      ColumnArr={ColumnArr}
                      selectedValues={selectedValues}
                      setSelectedValues={setSelectedValues}
                      pdfExportComponent={pdfExportComponent}
                      setFontSizeVal={setFontSizeVal}
                      fontSizeVal={fontSizeVal}
                      setPaperSizeVal={setPaperSizeVal}
                      paperSizeVal={paperSizeVal}
                      setLayoutVal={setLayoutVal}
                      layoutVal={layoutVal}
                      setScalePDF={setScalePDF}
                      scalePDF={scalePDF}
                      setMarginPDF={setMarginPDF}
                      marginPDF={marginPDF}
                      setScreenSizePerPdf={setScreenSizePerPdf}
                      screenSizePerPdf={screenSizePerPdf}
                      setDimensionOfPages={setDimensionOfPages}
                      contentRef={contentRef}
                      fileName="PF-Funds-Report.pdf"
                      printExcel={handleDownloadExcel}
                      printTXT={handleTXT}
                      printpdf={handleGeneratePdf}
                    />
                  </Row>
                )}

                <div
                  id="printDiv"
                  className="p-4"
                  style={{
                    color: "black",
                    minWidth: "200px",
                    overflowX: "auto",
                    width: "auto",
                  }}
                >
                  <div
                    style={{
                      width: `${
                        dimensionOfPages?.find(
                          (item) => item.key === paperSizeVal,
                        )?.dimensions[layoutVal === "Portrait" ? 0 : 1]
                      }`,
                      margin: "0 auto",
                      backgroundColor: "white",
                    }}
                    className="border"
                  >
                    <div style={{ margin: "0.25in" }} ref={contentRef}>
                      {tableData.length === 0 ? (
                        <div className="table-empty text-center">
                          <BsTable className="icon" />
                          <p className="text-primary">
                            No Settlement data found!
                          </p>
                        </div>
                      ) : (
                        <>
                          <div className="row align-items-center mb-3">
                            <div className="col-4">
                              <img
                                // src={companyName?.company_logo ? companyName?.company_logo : HBLLogo}
                                src={
                                  companyName?.company_logo
                                    ? companyName?.company_logo
                                    : ""
                                }
                                alt="Logo"
                                style={{ height: "33px" }}
                              />
                            </div>
                            <div className="col-4 text-center">
                              <h6 className="text-black mb-0">
                                Final Settlement Report
                              </h6>
                            </div>
                          </div>

                          {/* Employee Info */}
                          <Col className="px-0" xs={12}>
                            <div className="m-1 p-2 small">
                              <div className="card-header py-2 px-3 border-bottom">
                                <div className="text-black d-flex align-items-center">
                                  <span>Employee</span>
                                </div>
                              </div>
                              <div className="text-black card-body p-2">
                                <div className="d-flex flex-wrap">
                                  <div className="flex-item pr-5 pb-3">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="50"
                                      height="50"
                                      viewBox="0 0 50 50"
                                    >
                                      <path
                                        fill="#949494"
                                        d="M25 2.008c-12.69 0-23 10.31-23 23s10.31 23 23 23 23-10.31 23-23-10.31-23-23-23m0 2c11.61 0 21 9.39 21 21a20.92 20.92 0 0 1-6.012 14.705c-1.83-1.343-4.06-2.017-5.949-2.69-1.064-.378-2.02-.753-2.719-1.171-.668-.4-1.04-.813-1.236-1.286-.092-1.146-.073-2.07-.066-3.16.12-.12.276-.205.4-.351.292-.345.59-.764.873-1.235.487-.807.84-1.795 1.04-2.797.302-.154.626-.187.872-.502.455-.58.762-1.396.899-2.533.12-1.004-.203-1.694-.62-2.224.449-1.465 1.003-3.795.815-6.205-.104-1.327-.438-2.662-1.24-3.772-.767-1.06-2.011-1.822-3.604-2.098C28.442 8.541 26.835 8 24.914 8h-.018c-4.302.079-7.078 1.86-8.267 4.576-1.13 2.583-.887 5.799-.076 9.147-.436.53-.778 1.233-.655 2.265.137 1.137.444 1.954.899 2.533.246.315.57.348.873.502.198 1.001.552 1.988 1.039 2.795.284.471.58.89.873 1.235.124.146.28.233.4.353.007 1.09.025 2.013-.066 3.16-.196.472-.567.884-1.234 1.286-.698.42-1.653.797-2.715 1.177-1.887.677-4.116 1.355-5.951 2.688A20.92 20.92 0 0 1 4 25.007c0-11.609 9.39-21 21-21m-.078 5.994c1.844.002 3.004.548 3.322 1.105l.244.428.487.067c1.256.174 1.958.662 2.46 1.357.503.695.783 1.666.868 2.756.17 2.18-.454 4.754-.85 5.945l-.252.756.682.414c-.07-.042.32.189.232.92-.106.89-.334 1.343-.486 1.537s-.218.17-.201.168l-.824.068-.088.823c-.076.706-.473 1.67-.938 2.441a8 8 0 0 1-.687.975c-.208.245-.43.397-.346.353l-.535.28V31c0 1.324-.054 2.407.086 3.95l.011.132.047.125c.394 1.06 1.215 1.806 2.139 2.36s1.983.952 3.076 1.341c1.801.641 3.678 1.272 5.11 2.203A20.9 20.9 0 0 1 25 46.008c-5.134 0-9.829-1.84-13.475-4.893 1.44-.926 3.32-1.559 5.118-2.203 1.092-.391 2.149-.793 3.07-1.348.921-.554 1.74-1.301 2.133-2.357l.047-.125.011-.133c.139-1.54.086-2.624.086-3.949v-.605l-.535-.282c.084.044-.138-.108-.346-.353a8 8 0 0 1-.687-.973c-.465-.771-.862-1.736-.938-2.441l-.088-.823-.824-.068c.016.001-.049.026-.2-.168-.153-.194-.38-.647-.487-1.537-.088-.732.307-.965.232-.92l.635-.385-.186-.72c-.86-3.312-.99-6.325-.105-8.348.884-2.02 2.655-3.303 6.46-3.375"
                                      />
                                    </svg>
                                  </div>
                                  {PFFundSummary.map((item, i) => (
                                    <div
                                      className="flex-item pr-5 pb-3"
                                      key={i}
                                    >
                                      <CardColComponent
                                        title={item.title}
                                        subTitle={item.value}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </Col>

                          {/* Contribution + Loan Summary */}
                          <Col className="px-0" xs={12}>
                            <div className="m-1 p-2 small">
                              <div className="card-header py-2 px-3 border-bottom">
                                <div className="text-black d-flex align-items-center">
                                  {/* <span>Total Contribution</span> */}
                                  <span>Total Amounts</span>
                                </div>
                              </div>
                              <div className="text-black card-body p-2">
                                <div className="d-flex flex-wrap">
                                  {PFfundDetailsArr.map((item, i) => (
                                    <div
                                      className="flex-item pr-5 pb-3"
                                      key={i}
                                    >
                                      <CardColComponent
                                        title={item.title}
                                        subTitle={numberWithCommas(
                                          parseFloat(
                                            String(item.value),
                                          ).toFixed(item.fixed || 2),
                                        )}
                                        amount={item.isAmount}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </Col>

                          {/* Monthly Contribution Table */}
                          <Col className="px-0" xs={12}>
                            <div className="m-1 p-2 small">
                              <div className="card-header py-2 px-3 border-bottom">
                                <div className="text-black d-flex align-items-center">
                                  <span>Monthly Contribution Details</span>
                                </div>
                              </div>
                              <div className="text-black card-body p-2">
                                <table
                                  className=""
                                  style={{
                                    color: "black",
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    tableLayout: "fixed",
                                  }}
                                >
                                  <thead>
                                    <tr
                                      style={{
                                        borderTop: "2px solid black",
                                        borderBottom: "2px solid black",
                                      }}
                                    >
                                      {selectedValues.columns.includes(
                                        "Month",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "left",
                                            padding: "8px 4px",
                                            border: "none",
                                          }}
                                        >
                                          Month
                                        </th>
                                      )}
                                      {selectedValues.columns.includes(
                                        "Employee Contribution",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "12%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                            border: "none",
                                          }}
                                        >
                                          Employee Contribution
                                        </th>
                                      )}
                                      {selectedValues.columns.includes(
                                        "Employer Contribution",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "12%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                            border: "none",
                                          }}
                                        >
                                          Employer Contribution
                                        </th>
                                      )}
                                      {selectedValues.columns.includes(
                                        "Profit",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                            border: "none",
                                          }}
                                        >
                                          Profit
                                        </th>
                                      )}
                                      {selectedValues.columns.includes(
                                        "Total",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "right",
                                            padding: "8px 4px",
                                            border: "none",
                                          }}
                                        >
                                          Total
                                        </th>
                                      )}
                                      {selectedValues.columns.includes(
                                        "Remarks",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "11%",
                                            textAlign: "left",
                                            padding: "8px 4px",
                                            border: "none",
                                          }}
                                        >
                                          Remarks
                                        </th>
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {tableData.map((item, index) => (
                                      <tr className="border-bottom" key={index}>
                                        {selectedValues.columns.includes(
                                          "Month",
                                        ) && (
                                          <td
                                            id="test"
                                            style={{ width: "10%" }}
                                          >
                                            {moment(
                                              item.month_of_contribution,
                                            ).format("MMM, YYYY")}
                                          </td>
                                        )}
                                        {selectedValues.columns.includes(
                                          "Employee Contribution",
                                        ) && (
                                          <td
                                            id="test"
                                            className="text-right"
                                            style={{ width: "12%" }}
                                          >
                                            {decentStyle(
                                              numberWithCommas(
                                                parseFloat(
                                                  item.employee_contribution ||
                                                    0,
                                                ).toFixed(2),
                                              ),
                                            )}
                                            {/* {numberWithCommas(
                                                                                                parseFloat(
                                                                                                    item.employee_contribution || 0
                                                                                                ).toFixed(2)
                                                                                            )} */}
                                          </td>
                                        )}
                                        {selectedValues.columns.includes(
                                          "Employer Contribution",
                                        ) && (
                                          <td
                                            id="test"
                                            className="text-right"
                                            style={{ width: "12%" }}
                                          >
                                            {decentStyle(
                                              numberWithCommas(
                                                parseFloat(
                                                  item.employer_contribution ||
                                                    0,
                                                ).toFixed(2),
                                              ),
                                            )}
                                            {/* {numberWithCommas(
                                                                                                parseFloat(
                                                                                                    item.employer_contribution || 0
                                                                                                ).toFixed(2)
                                                                                            )} */}
                                          </td>
                                        )}
                                        {selectedValues.columns.includes(
                                          "Profit",
                                        ) && (
                                          <td
                                            id="test"
                                            className="text-right"
                                            style={{ width: "10%" }}
                                          >
                                            {decentStyle(
                                              numberWithCommas(
                                                parseFloat(
                                                  item.profit || 0,
                                                ).toFixed(2),
                                              ),
                                            )}
                                            {/* {numberWithCommas(
                                                                                                parseFloat(
                                                                                                    item.profit || 0
                                                                                                ).toFixed(2)
                                                                                            )} */}
                                          </td>
                                        )}
                                        {selectedValues.columns.includes(
                                          "Total",
                                        ) && (
                                          <td
                                            id="test"
                                            className="text-right"
                                            style={{ width: "10%" }}
                                          >
                                            {decentStyle(
                                              numberWithCommas(
                                                parseFloat(
                                                  item.total || 0,
                                                ).toFixed(2),
                                              ),
                                            )}
                                            {/* {numberWithCommas(
                                                                                                parseFloat(
                                                                                                    item.total || 0
                                                                                                ).toFixed(2)
                                                                                            )} */}
                                          </td>
                                        )}
                                        {selectedValues.columns.includes(
                                          "Remarks",
                                        ) && (
                                          <td
                                            id="test"
                                            className="text-left"
                                            style={{ width: "11%" }}
                                          >
                                            {item.remarks}
                                          </td>
                                        )}
                                      </tr>
                                    ))}
                                  </tbody>
                                  <tfoot>
                                    <tr
                                      style={{ borderTop: "2px solid black" }}
                                    >
                                      {selectedValues.columns.includes(
                                        "Month",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "left",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Total
                                        </th>
                                      )}
                                      {selectedValues.columns.includes(
                                        "Employee Contribution",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "12%",
                                            textAlign: "right",
                                          }}
                                        >
                                          {decentStyle(
                                            numberWithCommas(
                                              parseFloat(
                                                String(
                                                  summary.totalEmployeeContribution,
                                                ),
                                              ).toFixed(2),
                                            ),
                                          )}
                                          {/* {numberWithCommas(
                                                                                            parseFloat(
                                                                                                String(
                                                                                                    summary.totalEmployeeContribution
                                                                                                )
                                                                                            ).toFixed(2)
                                                                                        )} */}
                                        </th>
                                      )}
                                      {selectedValues.columns.includes(
                                        "Employer Contribution",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "12%",
                                            textAlign: "right",
                                          }}
                                        >
                                          {decentStyle(
                                            numberWithCommas(
                                              parseFloat(
                                                String(
                                                  summary.totalEmployerContribution,
                                                ),
                                              ).toFixed(2),
                                            ),
                                          )}
                                          {/* {numberWithCommas(
                                                                                            parseFloat(
                                                                                                String(
                                                                                                    summary.totalEmployerContribution
                                                                                                )
                                                                                            ).toFixed(2)
                                                                                        )} */}
                                        </th>
                                      )}
                                      {selectedValues.columns.includes(
                                        "Profit",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "right",
                                          }}
                                        >
                                          {decentStyle(
                                            numberWithCommas(
                                              parseFloat(
                                                String(summary.totalProfit),
                                              ).toFixed(2),
                                            ),
                                          )}
                                          {/* {numberWithCommas(
                                                                                            parseFloat(
                                                                                                String(summary.totalProfit)
                                                                                            ).toFixed(2)
                                                                                        )} */}
                                        </th>
                                      )}
                                      {selectedValues.columns.includes(
                                        "Total",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{
                                            width: "10%",
                                            textAlign: "right",
                                          }}
                                        >
                                          {decentStyle(
                                            numberWithCommas(
                                              parseFloat(
                                                String(summary.grandTotal),
                                              ).toFixed(2),
                                            ),
                                          )}
                                          {/* {numberWithCommas(
                                                                                            parseFloat(
                                                                                                String(summary.grandTotal)
                                                                                            ).toFixed(2)
                                                                                        )} */}
                                        </th>
                                      )}
                                      {selectedValues.columns.includes(
                                        "Remarks",
                                      ) && (
                                        <th
                                          id="test"
                                          style={{ width: "11%" }}
                                        ></th>
                                      )}
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                          </Col>

                          {/* Contribution + Loan Summary */}
                          <Col className="px-0" xs={12}>
                            <div className="m-1 p-2 small">
                              <div className="card-header py-2 px-3 border-bottom">
                                <div className="text-black d-flex align-items-center">
                                  <span>Net Payable Amount</span>
                                </div>
                              </div>
                              <div className="text-black card-body p-2">
                                <input
                                  className="form-control text-dark"
                                  type="text"
                                  value={numberWithCommas(summary?.netAmount)}
                                />
                                <span>{numberToWords(summary?.netAmount)}</span>
                              </div>
                            </div>
                          </Col>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </Col>
      </Row>
    </div>
  );
}

export default SettlementReportEmployee;
